import useTable from '../../../hooks/useTable';
import { Table } from '../../Table';
import { TableComponentProps } from '../types';

const columnLables = {
  aif_identifier_lei: {
    name: 'Legal Entity Identification code (LEI)',
    order: 6,
    letter: 'A'
  },
  aif_identifier_isin: {
    name: 'International Securities Identification Number (ISIN)',
    order: 7,
    letter: 'A'
  },
  aif_identifier_cusip: {
    name: 'Commodities on Uniform Securities Identification Procedures Number (CUSIP)',
    order: 8,
    letter: 'A'
  },
  aif_identifier_sedol: {
    name: 'Stock Exchange Daily Official List code (SEDOL)',
    order: 9,
    letter: 'A'
  },
  aif_identifier_ticker: {
    name: 'Bloomberg (ticker) code',
    order: 10,
    letter: 'A'
  },
  aif_identifier_ric: {
    name: 'Reuters Instrument Code (RIC)',
    order: 11,
    letter: 'A'
  },
  inception_date: {
    name: 'Inception date of the fund',
    order: 15,
    letter: 'A'
  },
  reporting_period_type: {
    name: 'Reporting period type',
    order: 16,
    letter: 'A'
  },
  reporting_period_start_date: {
    name: 'Start date',
    order: 17,
    letter: 'A'
  },
  reporting_period_end_date: {
    name: 'End date',
    order: 18,
    letter: 'A'
  },
  reporting_period_year: {
    name: 'Year',
    order: 19,
    letter: 'A'
  },
  filing_type: {
    name: 'Type of filing',
    order: 20,
    letter: 'A'
  },
  aif_reporting_code: {
    name: 'AIF Reporting Code',
    order: 249,
    letter: 'A'
  },
  aif_content_type: {
    name: 'Filing content',
    order: 21,
    letter: 'A'
  },
  aif_reporting_obligation_change_frequency_code: {
    name: 'Frequency change code',
    order: 22,
    letter: 'A'
  },
  aif_reporting_obligation_change_contents_code: {
    name: 'Contents change code',
    order: 23,
    letter: 'A'
  },
  aif_reporting_obligation_change_quarter: {
    name: 'First quarter in which a change occurred',
    order: 24,
    letter: 'A'
  },
  last_reporting_flag: {
    name: 'Is this the last report you will make for this fund?',
    order: 25,
    letter: 'A',
    disabled: true
  },
  aif_no_reporting_flag: {
    name: `Do you wish to submit a nil return?
    (If 'Yes', only fields 1A to 5A and 15A to 26A must be completed where applicable)`,
    order: 26,
    letter: 'A'
  }
};

export const FundIdentificationCodes = ({
  funds,
  currentDataKey,
  onChangeFund,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) => {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useTable({
    data: funds[currentDataKey]?.fund_data?.FUND_ID_CODES,
    onChangeFund,
    schema: schema.FUND_ID_CODES,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.FUND_ID_CODES?.field_names || [],
    isMultiFunds,
    funds,
    columnLables,
    tableName: 'FUND_ID_CODES'
  });

  return (
    <Table
      id="fca-reporttables-fund-identification-codes-table"
      handleChanges={onChange}
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 3 : null}
      stickyTopRows={isMultiFunds ? 1 : null}
      columns={columns}
      rows={rows}
    />
  );
};
